import { convertBlobToBase64, openPrinterWithUrl } from '@/utils/file';
import ConfirmationModal from '@/views/components/Modals/ConfirmationModal';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import { useGetOverChargePrintForm } from '@/views/screens/Claims/hooks';
import { pdf } from '@react-pdf/renderer';
import { Col, Row } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  createOverchargeClaimReset,
  sendOverChargeClaimPdfToCarrierInProgress,
} from '../../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { downloadBlobFile } from '../../../../../../../utilz';
import { routeFileSelector } from '../../../../../../../utilz/i18n';
import Button from '../../../../../../components/Buttons/Button';
import SecondaryLabel from '../../../../../../components/Labels/SecondaryLabel';
import OverChargeClaimDetailsPrint from '../../../../../Print/Claims/Overcharge/OverChargeClaimDetailsPrint';
import OverChargeDetailsPrintModal from '../../../Print/OverChargeDetailsPrintModal';

const OverChargeDrawerHeader = ({ claimNo, currency }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const dispatch = useDispatch();
  const [printModal, setPrintModal] = useState(false);
  const claimDetails = useSelector((state) => state.overChargeClaims.claimDetails);
  const createClaim = useSelector((state) => state.overChargeClaims.createClaim);
  const sendPdfToCarrier = useSelector((state) => state.overChargeClaims.sendPdfToCarrier);

  const { data: claimPrintDetails, isLoading: isClaimPrintDetailsLoading } = useGetOverChargePrintForm({
    FBOCKey: claimDetails?.data?.fbOcKey,
  });

  const handleDefaultEmailSendDialogueCancel = () => {
    dispatch(createOverchargeClaimReset());
  };
  const generatePDF = async (data, sendEmail) => {
    try {
      const fileName = 'OC Claim Details';
      const blob = await pdf(<OverChargeClaimDetailsPrint claimDetails={data} namespace={namespace} />).toBlob();

      if (sendEmail) {
        const fileBase64 = await convertBlobToBase64(blob);

        const handleDone = () => {
          setPrintModal(false);
          downloadBlobFile(blob, fileName);
        };

        const payload = {
          fbocKey: claimDetails?.data?.fbOcKey,
          carrierKey: claimDetails?.data?.carrierKey,
          attachment: String(fileBase64).split(',')[1],
          self: 1,
          isCustom: 0,
          customEmailAddress: null,
          handleDone,
        };
        dispatch(sendOverChargeClaimPdfToCarrierInProgress(payload));
      } else {
        downloadBlobFile(blob, fileName);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handlePrint = async () => {
    let pdfUrl = '';
    try {
      const blob = await pdf(
        <OverChargeClaimDetailsPrint claimDetails={claimPrintDetails} namespace={namespace} />,
      ).toBlob();
      pdfUrl = URL.createObjectURL(blob);
      await openPrinterWithUrl(pdfUrl, 'oc_claims-pdf-print-iframe');
    } catch {
      showNotification({
        type: NOTIFICATION_TYPES.ERROR,
        message: t('translation:default.fields.printError'),
      });
    } finally {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    }
  };
  return (
    <Row className="flex-nowrap" gutter={30} align="middle">
      <Col className="flex-1">
        <Row className="flex-nowrap" gutter={30} align="middle">
          <Col>
            <Row align="middle" gutter={5}>
              <Col className="">
                <SecondaryLabel className="f-14  text-white fw-600">
                  {t('translation:default.fields.claimNumber')} :
                </SecondaryLabel>
              </Col>
              <Col>
                <SecondaryLabel className="f-16 text-white fw-600">{claimNo}</SecondaryLabel>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row align="middle" gutter={5}>
              <Col className="">
                <SecondaryLabel className="f-14  text-white fw-600">
                  {t('translation:default.fields.currency.label')} :
                </SecondaryLabel>
              </Col>
              <Col>
                <SecondaryLabel className="f-16 text-white fw-600">{currency}</SecondaryLabel>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col className="pr-30">
        <Row gutter={15}>
          <Col>
            <Button type="default" invertMode onClick={() => setPrintModal(true)}>
              Print Form
            </Button>
          </Col>
          <Col>
            <Button
              loading={sendPdfToCarrier?.progressing}
              onClick={() => generatePDF(claimPrintDetails, true)}
              invertMode
            >
              {t('translation:claims.emailToTransportationProvider')}
            </Button>
          </Col>
        </Row>
      </Col>
      <OverChargeDetailsPrintModal
        claimDetails={claimPrintDetails ? claimPrintDetails : {}}
        open={printModal}
        setOpen={setPrintModal}
        isLoading={isClaimPrintDetailsLoading}
        generatePDF={generatePDF}
        handlePrint={handlePrint}
      />
      <ConfirmationModal
        className="w-auto"
        title="Alert"
        open={createClaim.success && claimDetails.success && !claimDetails.progressing}
        description={
          <>
            {t('translation:claims.successFullyCreated')}. {t('translation:default.fields.claimNumber')} : {claimNo}{' '}
            <br />
            {t('translation:claims.sendEmailToTransportationProviderConfirmation')}
          </>
        }
        onOk={() => {
          generatePDF(claimPrintDetails, true);
          handleDefaultEmailSendDialogueCancel();
        }}
        onClose={handleDefaultEmailSendDialogueCancel}
        onCancel={handleDefaultEmailSendDialogueCancel}
      />
    </Row>
  );
};

export default OverChargeDrawerHeader;
